import { useMemo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Button } from 'foundations-components/transitional/components/Button';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RequiredAppPermissionsList, ConditionallyRequiredAppPermissionsList, RemovedAppPermissionsList, OptionalAppPermissionsList } from '../dataPermissions/AppPermissionsList';
import { ContainerTemplate } from './ContainerTemplate';
import { useDataPermissions } from '../../contexts/DataPermissionsContext';
import { useShowDataPermissions } from '../../hooks/queries/useShowDataPermissions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const appConfigPermissions = permissions => permissions.filter(permission => permission.isOnAppConfig);
export function DataPermissions({
  hasDataPermissions,
  requiredAppPermissions,
  conditionallyRequiredAppPermissions,
  optionalAppPermissions,
  permissionsNotOnAppConfig = [],
  onOpenInstallPermissions
}) {
  const {
    updatedOptionalPermissions,
    setUpdatedOptionalPermissions,
    updatedConditionallyRequiredPermissions,
    setUpdatedConditionallyRequiredPermissions
  } = useDataPermissions();
  const showDataPermissions = useShowDataPermissions(hasDataPermissions);
  const filteredRequiredPermissions = useMemo(() => appConfigPermissions(requiredAppPermissions), [requiredAppPermissions]);
  const filteredConditionallyRequiredPermissions = useMemo(() => appConfigPermissions(conditionallyRequiredAppPermissions), [conditionallyRequiredAppPermissions]);
  const filteredOptionalPermissions = useMemo(() => appConfigPermissions(optionalAppPermissions), [optionalAppPermissions]);
  if (showDataPermissions === false) {
    return /*#__PURE__*/_jsx(EmptyState, {
      layout: "horizontal",
      secondaryContentWidth: 200,
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.dataPermissions.emptyState.title"
      }),
      primaryContent: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "400",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "app-governance-lib.dataPermissions.emptyState.description"
        }), onOpenInstallPermissions && /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Button, {
            "data-selenium": "data-permissions-open-install-permissions",
            use: "primary",
            onClick: onOpenInstallPermissions,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app-governance-lib.dataPermissions.emptyState.openInstallPermissions"
            })
          })
        })]
      }),
      secondaryContent: /*#__PURE__*/_jsx(Illustration, {
        name: "empty-state-charts",
        width: "100%"
      })
    });
  }
  return /*#__PURE__*/_jsx(ContainerTemplate, {
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.dataPermissions.description"
    }),
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "600",
      "data-selenium": "data-permissions-content",
      children: [/*#__PURE__*/_jsx(RemovedAppPermissionsList, {
        permissions: permissionsNotOnAppConfig
      }), /*#__PURE__*/_jsx(RequiredAppPermissionsList, {
        permissions: filteredRequiredPermissions
      }), /*#__PURE__*/_jsx(ConditionallyRequiredAppPermissionsList, {
        changedPermissions: updatedConditionallyRequiredPermissions,
        setChangedPermissions: setUpdatedConditionallyRequiredPermissions,
        permissions: filteredConditionallyRequiredPermissions
      }), /*#__PURE__*/_jsx(OptionalAppPermissionsList, {
        changedPermissions: updatedOptionalPermissions,
        setChangedPermissions: setUpdatedOptionalPermissions,
        permissions: filteredOptionalPermissions
      })]
    })
  });
}